.head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin: 0;
  padding: 12px 14px;
  border-bottom: 1px solid var(--line-2);
  font-size: var(--t-body);
}

.sp {
  flex: 1 1 auto;
}

.stale {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.entries {
  margin: 0;
  padding: 0;
  list-style: none;
}

.entry {
  display: grid;
  grid-template-columns: minmax(10rem, 1.4fr) minmax(8rem, 1fr) minmax(12rem, 1.6fr) auto;
  gap: 4px 12px;
  align-items: baseline;
  padding: 10px 14px;
  border-bottom: 1px solid var(--line-2);
  font-size: var(--t-dense);
}

.entry:last-child {
  border-bottom: 0;
}

.who small,
.when small,
.muted {
  color: var(--muted);
}

.seq {
  color: var(--accent);
  font-weight: 650;
}

.note {
  margin: 0;
  padding: 10px 14px;
  border-top: 1px solid var(--line-2);
  font-size: var(--t-dense);
  color: var(--ink-2);
}

@media (max-width: 720px) {
  .entry {
    grid-template-columns: 1fr;
  }
}

/* A figure in the list of changes: a link to its receipt in the table's own voice. */
.figure {
  padding: 0;
  border: 0;
  background: none;
  color: var(--accent);
  font: inherit;
  font-weight: 650;
  text-decoration: underline;
  text-decoration-style: dotted;
  text-underline-offset: 3px;
  cursor: pointer;
}

.figure:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
  border-radius: 2px;
}
